import { Body02 } from 'Components/designSystem';
import styled from 'styled-components';


const TopText = styled(Body02)`
    padding: ${ ({ theme }) => theme.size.size_30 } 0;

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
        padding: ${ ({ theme }) => theme.size.size_20 };
    }
`;

export default TopText;

